import axios from './mayiRequest'
import Cookies from 'js-cookie'

export function fetchRedpacket(ids) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/redpacket/searchactivitybyactivityidlist', {
    activityIdList: ids
  })
}

export function doRedpacket({ ids, requereRedPacketInfo }) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/promotion/redpacket/sendcouponbatch', {
    sendCouponBatchs: ids,
    requereRedPacketInfo,
    tujia_code: Cookies.get('tujia_code') || '',
    tujia_code_site: Cookies.get('tujia_code_site') || ''
  })
}
